import { IconFont, SignTitle, BaseDrawer } from '@/components'
import { Button, Drawer, Typography, Checkbox } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useGetDetailV1 } from './utils'
import { t } from '@/i18n'
export const SiteDetailModal = (props: {
  visible: { visible: boolean; id: string }
  fingerprintData: any
  closeModal: () => void
}) => {
  const { visible, cancel, fingerprintData, closeModal } = props
  const [detail, getDetail] = useGetDetailV1()
  const [detailPattern, setDetaiPattern] = useState(1)
  const [componentKey, setComponentKey] = useState({ visible: false, key: 1 })
  useEffect(() => {
    if (visible.visible) {
      getDetail({ id: visible.id })
        .then(res => {
          // console.log(res)
          setDetaiPattern(res.data.detection_type)
        })
        .catch(_ => {})
    }
  }, [visible])
  const OS = useMemo(() => {
    let map = new Map()
    if (fingerprintData?.osList?.length > 0) {
      fingerprintData?.osList?.map(item => {
        map.set(item.id, item.name)
      })
    }
    return map
  }, [fingerprintData])
  const Language = useMemo(() => {
    let map = new Map()
    if (fingerprintData?.languageList?.length > 0) {
      fingerprintData?.languageList?.map(item => {
        map.set(item.id, item.name)
      })
    }
    return map
  }, [fingerprintData])
  const DB = useMemo(() => {
    let map = new Map()
    if (fingerprintData?.dbList?.length > 0) {
      fingerprintData?.dbList?.map(item => {
        map.set(item.id, item.name)
      })
    }
    return map
  }, [fingerprintData])

  return (
    <Detail
      onClose={() => {
        closeModal()
      }}
      open={visible.visible}
      title={t('详情')}
      props={{ width: 600 }}
      className="detail-drawer"
    >
      <div className="main">
        <div className="flex">
          <div className="title">{t('站点：')}</div>
          <Typography.Text
            ellipsis={{
              tooltip: {
                getPopupContainer: () => document.body,
              },
            }}
            className="text"
          >
            {detail?.site}
          </Typography.Text>
        </div>
        <div className="flex">
          <div className="title">{t('站点名称：')}</div>
          <Typography.Text
            ellipsis={{
              tooltip: {
                getPopupContainer: () => document.body,
              },
            }}
            className="text"
          >
            {detail?.siteName || '-'}
          </Typography.Text>
        </div>
        <div>
          <div className="bold-title">{t('基础配置')}</div>
          <>
            <div className="flex">
              <div className="title">{t('安全域：')}</div>
              <div className="text">{detail?.areaName}</div>
            </div>
            <div className="flex">
              <div className="title">{t('认证方式：')}</div>
              <div className="text">
                {detail?.authMode === 'AuthModeProtocolAuth'
                  ? t('协议认证')
                  : detail?.authMode === 'AuthModeCookieAuth'
                  ? t('Cookies认证')
                  : t('无认证')}
              </div>
            </div>
            {detail.authMode === 'AuthModeCookieAuth' && detail?.cookieAuth !== '' ? (
              <div className="flex">
                <div className="title">Cookie：</div>
                <div className="text">{detail?.cookieAuth}</div>
              </div>
            ) : null}
            {detail.authMode === 'AuthModeProtocolAuth' && (
              <>
                <div className="flex">
                  <div className="title">{t('用户名：')}</div>
                  <div className="text">{detail?.protocolAuth?.username}</div>
                </div>
                <div className="flex">
                  <div className="title">{t('密码：')}</div>
                  <div className="text">{detail?.protocolAuth?.password}</div>
                </div>
              </>
            )}
            <div className="flex">
              <div className="title">{t('关联安全设备：')}</div>
              <div className="text">
                {(() => {
                  // 按设备类型分组
                  const groupedDevices = (detail?.device || []).reduce((acc, item) => {
                    if (!acc[item.deviceType]) {
                      acc[item.deviceType] = []
                    }
                    acc[item.deviceType].push(item)
                    return acc
                  }, {} as Record<string, typeof detail.device>)

                  // 格式化显示
                  return (
                    Object.entries(groupedDevices || {})
                      .map(([type, devices]: [string, typeof detail.device]) => {
                        const deviceList = devices
                          .map(device => `${device.deviceName}（${device.deviceIp}）`)
                          .join('、')
                        return `${type}：${deviceList}`
                      })
                      .join('、') || '-'
                  )
                })()}
              </div>
            </div>
            <div className="flex">
              <div className="title">{t('默认验证设备：')}</div>
              <div className="text">
                {(() => {
                  // 按设备类型分组
                  const groupedDevices = (detail?.defaultVerifyDevice || []).reduce((acc, item) => {
                    if (!acc[item.deviceType]) {
                      acc[item.deviceType] = []
                    }
                    acc[item.deviceType].push(item)
                    return acc
                  }, {} as Record<string, typeof detail.defaultVerifyDevice>)

                  // 格式化显示
                  return (
                    Object.entries(groupedDevices || {})
                      .map(([type, devices]: [string, typeof detail.defaultVerifyDevice]) => {
                        const deviceList = devices
                          .map(device => `${device.deviceName}（${device.deviceIp}）`)
                          .join('、')
                        return `${type}：${deviceList}`
                      })
                      .join('、') || '-'
                  )
                })()}
              </div>
            </div>
            <div className="flex">
              <div className="title">{t('WAF防护检测开关')}:</div>
              <div className="text">{detail?.wafDetectSwitch ? t('开启') : t('关闭')}</div>
            </div>
          </>
          <div className="bold-title">{t('指纹信息')}</div>
          <div className="flex">
            <div className="title">{t('操作系统：')}</div>
            <div className="text">{OS.get(detail?.os?.id) || '-'}</div>
          </div>
          <div className="flex">
            <div className="title">{t('数据库：')}</div>
            <div className="text">{DB.get(detail?.db?.id) || '-'}</div>
          </div>

          <div className="flex">
            <div className="title">{t('开发语言：')}</div>
            <div className="text">{Language.get(detail?.language?.id) || '-'}</div>
          </div>
          <div className="flex">
            <div className="title">{t('影响组件：')}</div>
            <div>
              <Typography.Paragraph
                key={componentKey.key}
                style={{ margin: 0 }}
                // className="describe"
              >
                {detail?.componentName?.split(',').length > 0
                  ? detail?.componentName
                      ?.split(',')
                      .map(item => <div key={item}>{item || '-'}</div>)
                  : '-'}
              </Typography.Paragraph>
            </div>
          </div>
          <div className="bold-title">{t('其它')}</div>
          <div className="remark">
            <div className="title">{t('备注：')}</div>
            <div className="content" style={{ flex: 1 }}>
              {detail?.remark || '-'}
            </div>
          </div>
        </div>
      </div>
    </Detail>
  )
}

const Detail = styled(BaseDrawer)`
  &.detail-drawer {
  .ant-drawer-header {
    padding: 16px 24px;
    height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;

    .ant-drawer-title {
      color: #4238c9;
      font-weight: 500;
    }
  }
  .ant-drawer-body {
    padding: 24px;

    .main {
      .flex {
        display: flex;
        align-items: flex-start;
        margin-bottom: 24px;
        transition: all 0.3s ease;
      }

      .bold-title {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        margin: 32px 0 24px;

        &:first-child {
          margin-top: 0;
        }
      }

      .title {
        width: 140px;
        color: #86909c;
        font-size: 14px;
      }

      .text {
        width: 450px;
        font-size: 14px;
        color: #333333;
      }

      .content {
        width: 100%;
        border-radius: 8px;
        line-height: 1.5;
      }

      .remark {
        display: flex;
        align-items: flex-start;
      }

      .time_out {
        background: #f8f9fb;
        border-radius: 8px;
        padding: 12px 16px;
        overflow-y: auto;
        word-break: break-all;
        word-wrap: break-word;
        line-height: 1.5;

        &:hover {
          background: #f0f2f5;
        }
      }
    }
  }

  .ant-drawer-footer {
    border-top: 1px solid #f0f0f0;
    padding: 16px 24px;
  }
`

const Divider = styled.div`
  margin: 24px 0;
  border-bottom: 1px dashed #dee1e4;
`

const DeviceContainer = styled.div`
  background: #f8f9fb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.5;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f2f5;
  }

  .line {
    display: flex;
    align-items: center;
  }

  .title {
    width: 70px;
    color: #86909c;
    margin-right: 8px;
  }

  .value {
    width: 100px;
    color: #4238c9;
  }

  .value1 {
    width: 200px;
    color: #4238c9;
  }
`
